import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommentDto } from '@app/generated/model';
import { Subject, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { CommentsState } from '@app/core/store/reducers/comments';
import { getMIPSComments } from '@dwo/selectors';

export class MipsComment {
  referenceType: string;
  commentText: string;
  displayTitle: string;
}

const defaultComments: MipsComment[] = [
  { referenceType: 'MIPS_CONSTRUCTION', displayTitle: 'Construction Comments:', commentText: '-' },
  { referenceType: 'MIPS_ENGINEERING', displayTitle: 'Engineering Comments:', commentText: '-' },
  { referenceType: 'MIPS_MATERIAL', displayTitle: 'Material Comments:', commentText: '-' },
];

@Component({
  selector: 'app-mips-comments',
  templateUrl: './mips-comments.component.html',
  styleUrls: ['./mips-comments.component.scss'],
  standalone: false,
})
export class MIPSCommentsComponent implements OnInit, OnDestroy {
  public comments: CommentDto[];
  public mipsComments: MipsComment[] = [];
  private readonly destroy$ = new Subject<void>();

  constructor(private store: Store<CommentsState>) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.store
      .select(getMIPSComments)
      .pipe(takeUntil(this.destroy$))
      .subscribe((comments) => {
        this.mipsComments = defaultComments.map((comment) => ({ ...comment }));
        if (comments?.length) {
          this.comments = comments;
          comments.forEach((comment) => {
            const mipsComment = this.mipsComments.find((f) => f.referenceType === comment.referenceType);
            if (mipsComment) {
              mipsComment.commentText = comment.text;
            }
          });
        }
      });
  }

  // translateToMipsComment(comment : CommentDto): MipsComment {
  //   let mipsComment = new MipsComment();
  //   mipsComment.commentText = comment.text;
  //   mipsComment.referenceType = comment.referenceType;
  //   return mipsComment;
  // }
}
